import type { ColDef } from "ag-grid-enterprise";

/**
 * Row dates serialize as "YYYY-MM-DD HH:MM:SS" text. With no comparator, AG-Grid's default
 * date filter compares that string against a Date via `<`/`>`, which JS coerces into a
 * lexicographic string comparison — always "less than". CSRM-only: SSRM filters server-side.
 */
function parseGridDateString(value: string | null | undefined): Date | null {
  const match = value ? /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/.exec(value) : null;
  if (!match) return null;

  const [, year, month, day, hour, minute, second] = match.map(Number);
  return new Date(year, month - 1, day, hour, minute, second);
}

// Matches AG-Grid's own documented custom date comparator shape — filterLocalDateAtMidnight
// is always a day boundary, so the cell's date is truncated to midnight for comparison.
function dateStringComparator(filterLocalDateAtMidnight: Date, cellValue: string | null | undefined): number {
  const cellDate = parseGridDateString(cellValue);
  if (!cellDate) return -1;

  cellDate.setHours(0, 0, 0, 0);
  if (cellDate < filterLocalDateAtMidnight) return -1;
  if (cellDate > filterLocalDateAtMidnight) return 1;
  return 0;
}

export function withDateFilterComparator(columnDefs: ColDef[]): ColDef[] {
  return columnDefs.map((c) =>
    c.filter === "agDateColumnFilter"
      ? { ...c, filterParams: { ...((c.filterParams as Record<string, unknown>) ?? {}), comparator: dateStringComparator } }
      : c
  );
}
